import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import {
  assignUserRolesAdmin,
  assignUserRolesSuperAdmin,
} from "../constants/UserRoles";
import { Grid, FormHelperText } from "@mui/material";
import DialogWrapper from "./DialogWrapper";
import StyledSelect from "./elements/StyledSelect";
import StyledTextField from "./elements/StyledTextField";
import StyledSwitchField from "./elements/StyledSwitchField";
import MultiSelectChip from "./elements/MultiSelectChip";
import CustomAutoComplete from "./elements/AutoComplete";
import { joiResolver } from "@hookform/resolvers/joi";
import { useForm } from "react-hook-form";
import { userSchema } from "../validation/UserSchemas";
import { getAllUsersFromAzureAD } from "../services/api/azureAD.api";
import { toast } from "react-toastify";
import {
  WEB_MAP,
  WEB_PORTAL,
} from "../constants/AppPermissionModels";
export default function UserModal({
  open,
  setOpen,
  userData,
  handleCreateNewUser,
  handleEditUser,
  edit,
  moduleOptions,
  pageRerender,
  groupOptions,
  ...props
}) {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    control,
    watch,
  } = useForm({
    resolver: joiResolver(userSchema),
  });

  let cancelToken;
  const timeout = useRef();

  const [role, setRole] = useState("init");
  const [model, setModel] = useState("init");
  const [models, setModels] = useState([]);
  const [email, setEmail] = useState(null);
  const [name, setName] = useState(null);
  const [moduleAssignOptions, setModuleAssignOption] = useState(moduleOptions);
  const [errMsg, setErrMsg] = useState(null);
  const [errorMessageSite, setErrorMessageSite] = useState(null);
  const [emailOptions, setEmailOptions] = useState([]);
  const [group, setGroup] = useState("init");
  const [groups, setGroups] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));
  const watchFields = watch();

  useEffect(() => {
    setValue("templates", []);
    setValue("user_group", []);
  }, []);

  const resetAll = () => {
    setValue("email", null);
    setValue("templates", []);
    setValue("name", null);
    setValue("user_role", null);
    setEmail(null);
    setName(null);
    setRole("init");
    setModel("init");
    setModels([]);
    setValue("web_portal_access", false);
    setValue("web_map_access", false);
    setValue("edotco_site_access", true);
    setValue("operator_site_access", true);
    setValue("user_group", []);
    setGroups([]);
    setGroup("init");
  };

  useEffect(() => {
    if (userData) {
      setModels(userData.templates);
      setRole(userData.user_role);
      setEmail(userData.email);
      setName(userData.name);
      setValue("id", userData.id);
      setValue("email", userData.email);
      setValue("name", userData.name);
      setValue("user_role", userData.user_role);
      setValue("templates", userData.templates);
      setValue(
        "web_portal_access",
        userData.web_app_access?.includes(WEB_PORTAL)
      );
      setValue("web_map_access", userData.web_app_access?.includes(WEB_MAP));
      setValue(
        "edotco_site_access", true);
      setValue(
        "operator_site_access", true);
      setGroups(userData?.group_name);
      setValue("user_group", userData?.group_name);
    }
  }, [userData, setValue]);

  useEffect(() => {
    if (
      watchFields["web_portal_access"] === true ||
      watchFields["web_map_access"] === true
    ) {
      setErrMsg(null);
    }
    if (
      watchFields["edotco_site_access"] === true ||
      watchFields["operator_site_access"] === true
    ) {
      setErrorMessageSite(null);
    }
  }, [watchFields]);

  useEffect(() => {
    if (!getValues("web_map_access")) {
      setValue("edotco_site_access", true);
      setValue("operator_site_access", true);
    }
    // eslint-disable-next-line
  }, [getValues("web_map_access")]);

  const handleDelete = (e) => {
    var index = models.findIndex(function (o) {
      if (o) {
        return o.name === e;
      }
    });
    if (index !== -1) models.splice(index, 1);
    setModels([...models]);
    setValue("templates", [...models]);
  };

  const assignRoles = (e) => {
    setRole(e);
    setValue("user_role", e);
  };

  const assignGroup = (e) => {
    const available = groups?.find((element) => element.name === e);
    const filterGroups = groupOptions.filter((data) => {
      return data.label === e;
    });
    const GroupsWithName = filterGroups.map((m) => {
      return { group_id: m.group_id, name: m.label };
    });
    if (available) {
      toast.error("Group is already assigned", { theme: "colored" });
      setGroup("init");
      return;
    }
    const newGroups = [...groups, ...GroupsWithName];
    setGroups([...newGroups]);
    setGroup("init");
    setValue("user_group", [...newGroups]);
  };


  const handleDeleteGroup = (e) => {
    var index = groups.findIndex(function (o) {
      if (o) {
        return o.name === e;
      }
    });
    if (index !== -1) groups.splice(index, 1);
    setGroups([...groups]);
    setValue("user_group", [...groups]);
  };

  const assignModels = (e) => {
    const available = models.find((element) => element.name === e);
    if (e === "Assign All") {
      const allModels = moduleAssignOptions.map((data) => {
        if (data.label !== "Assign All") {
          return {
            template_id: data.template_id,
            name: data.label,
          };
        }
      });
      const filteredModels = allModels.filter(function (x) {
        return x !== undefined;
      });
      setModels([...filteredModels]);
      setValue("templates", [...filteredModels]);
      setModel("init");
      return;
    }
    if (available) {
      toast.error("Module is already assigned", { theme: "colored" });
      setModel("init");
      return;
    }
    const filterModel = moduleAssignOptions.filter((data) => {
      return data.label === e;
    });
    const ModelsWithName = filterModel.map((m) => {
      return { template_id: m.template_id, name: m.label };
    });
    const newModels = [...models, ...ModelsWithName];
    setModels([...newModels]);
    setValue("templates", [...newModels]);
    setModel("init");
  };

  const submitUserInformation = (e) => {
      setOpen(false);
      if (!edit) {
        handleCreateNewUser(e);
        return resetAll();
      }
      handleEditUser(e);
      resetAll();
      setErrMsg(null);
      setErrorMessageSite(null);
  };

  useEffect(() => {
    setModuleAssignOption(moduleOptions);
  }, [moduleOptions]);

  const cancelAction = () => {
    clearErrors();
    if (!edit) {
      resetAll();
    }
    setOpen(false);
    pageRerender();
  };

  const getUsersFromAD = async (value) => {
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.");
    }
    //Save the cancel token for the current request
    cancelToken = axios.CancelToken.source();
    clearTimeout(timeout.current);
    if (!value.trim()) {
      return;
    }
    timeout.current = setTimeout(() => {
      try {
        getAllUsersFromAzureAD(value, cancelToken)
          .then(({ data: { data } }) => {
            let formattedEmailOptions = data.map((item) => {
              return {
                ...item,
                formattedEmail: `${item.email} (${item.name})`,
              };
            });
            setEmailOptions([...formattedEmailOptions]);
          })
          .catch((err) => {
            /*toast.error(`Error while retrieving azure active directory emails.`, {
              theme: "colored",
            });*/
          });
      } catch (err) {
        toast.error(`Unauthorized to access azure active directory emails.`, {
          theme: "colored",
        });
      }
    }, 600);
  };

  return (
    <DialogWrapper
      title={edit ? "Save" : "Add User"}
      cancelLabel="Cancel"
      actionLabel={edit ? "Save" : "Add User"}
      open={open}
      setOpenModal={setOpen}
      acceptButton={() => {
        if (role === "Admin" || role === "Super Admin") {
          setValue("templates", ["value"]);
        }
        if (role === "init") {
          setValue("user_role", null);
        }
        handleSubmit(submitUserInformation)();
      }}
      cancelAction={cancelAction}
      onClose={() => {
        cancelAction();
      }}
    >
      <Grid container spacing={3} justifyContent="flex-start">
        <Grid item justifyContent="center" xs={6}>
          <Grid
            item
            xs={12}
            style={{ paddingLeft: "16px", paddingTop: "16px" }}
          >
            <CustomAutoComplete
              id="email"
              defaultValue={email}
              label={"Email"}
              disabled={edit ? true : false}
              options={emailOptions}
              value={email}
              placeholder="Input User Email"
              setValue={(email) => {
                setEmail(email);
                setValue("email", email);
              }}
              setName={(name) => {
                setName(name);
                setValue("name", name);
              }}
              inputProps={{ ...register("email") }}
              error={errors.email ? true : false}
              helperText={errors.email ? "Enter Valid Email" : null}
              onTypeLetters={(value) => {
                getUsersFromAD(value);
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ paddingLeft: "16px", paddingTop: "16px" }}
          >
            <StyledSelect
              label={"User Role"}
              defaultVal={"Select the Role"}
              options={
                user?.user_role === "admin"
                  ? assignUserRolesAdmin
                  : assignUserRolesSuperAdmin
              }
              //disabled={edit ? true : false}
              control={role}
              setControl={assignRoles}
              error={errors.user_role ? true : false}
              helperText={errors.user_role ? "Enter Valid Role" : null}
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ paddingLeft: "16px", paddingTop: "16px" }}
          >
            <StyledSelect
              label={"Assign User Group"}
              defaultVal={"Select User Group"}
              options={groupOptions}
              control={group}
              setControl={assignGroup}
              error={errors.user_group ? true : false}
              helperText={errors.user_group ? "Enter Valid Group" : null}
            />
            <MultiSelectChip models={groups} handleDelete={handleDeleteGroup} />
          </Grid>
        </Grid>
        <Grid item justifyContent="center" xs={6}>
          <Grid
            item
            xs={12}
            style={{ paddingLeft: "16px", paddingTop: "16px" }}
          >
            <StyledTextField
              id="name"
              label="Name"
              defaultValue={name}
              disabled={edit ? true : false}
              inputProps={{ ...register("name") }}
              error={errors.name ? true : false}
              helperText={errors.name ? "Enter Valid Name" : null}
              placeholder="Input Name"
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ paddingLeft: "16px", paddingTop: "16px" }}
          >
            {role === "Admin" || role === "Super Admin" ? (
              <></>
            ) : (
              <>
                <StyledSelect
                  label={"Assign Modules"}
                  defaultVal={"Select Assign Modules"}
                  options={moduleAssignOptions}
                  control={model}
                  setControl={assignModels}
                  error={errors.templates ? true : false}
                  helperText={errors.templates ? "Enter Valid Modules" : null}
                />
                <MultiSelectChip models={models} handleDelete={handleDelete} />
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </DialogWrapper>
  );
}
